const config = {
  ssoUrl: 'https://quality.bigroad.com/partner-sign-in/freight', // BigRoad Staging
};

export default config;
